import CustomerIcon from './CustomerIcon';

export default CustomerIcon;
